/**
 * Created by Christof Sander on 20.10.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],


	methods: {
		getDBCategories: function(allCategories, tagScopeCategories, selectedCategories){
			var result = [];
			var categories = {
				tagScope: {},
				selected: {}
			};

			utils.forEach(tagScopeCategories, function(tagScopeCategory){
				categories.tagScope[tagScopeCategory.attributes.categoryID] = tagScopeCategory.attributes;
			});
			utils.forEach(selectedCategories, function(selectedCategory){
				categories.selected[selectedCategory.id] = selectedCategory;
			});

			utils.forEach(allCategories, function(category){
				if(categories.selected[category.id] && !categories.tagScope[category.id]){
					// add
					result.push({
						attributes: {
							categoryID: category.id
						}
					});
				}
				else if(!categories.selected[category.id] && categories.tagScope[category.id]) {
					// delete
					result.push({
						attributes: {
							tagScopeCategoryID: categories.tagScope[category.id].tagScopeCategoryID
						},
						type: 'delete'
					});
				}
			});

			// utils.forEach(selectedCategories, function(selectedCategory){
			// 	categories[selectedCategory.id] = selectedCategory;
			// });
			//
			// utils.forEach(allCategories, function(category){
			// 	if(categories[category.id]){
			// 		// add
			// 		result.push({
			// 			attributes: {
			// 				categoryID: category.id
			// 			}
			// 		});
			// 	}
			// 	else {
			// 		// delete
			// 		result.push({
			// 			attributes: {
			// 				tagScopeCategoryID: categories[category.id].tagScopeCategoryID
			// 			},
			// 			type: 'delete'
			// 		});
			// 	}
			// });

			return result;
		},

		onDecision: function(options){
			if(options.decisionType === 'submit' && options.decisionOptions && options.decisionOptions.type === 'categories'){
				var categoryTreesComponent = this.registry.categories.component;
				var tagScopeCategories;
				if(!this.config.creationMode) tagScopeCategories = this.resourceData.data.children.cms_tagScopes_categories.data;
				var categories = this.getDBCategories(
					categoryTreesComponent.registry[0].tree.resourceData.treeData.nodes,
					tagScopeCategories,
					options.data
				);

				if(!this.model.dirtyFields)                                 		this.model.dirtyFields = {};
				if(!this.model.dirtyFields.data)                            		this.model.dirtyFields.data = {};
				if(!this.model.dirtyFields.data.children)                   		this.model.dirtyFields.data.children = {};
				if(!this.model.dirtyFields.data.children.cms_tagScopes_categories)  this.model.dirtyFields.data.children.cms_tagScopes_categories = {};

				this.model.dirtyFields.data.children.cms_tagScopes_categories.data = categories;

				if(categories.length > 0)   this.setDirty();
				else                        this.setClean();
			}
		},

		onAttachDone: function(){
			// preselect categories if necessary
			if(!this.config.creationMode){
				var self = this;
				this.registry.categories.component.treesReady(function(){
					self.registry.categories.component.preSelectCategories(
						self.resourceData.data.children.cms_tagScopes_categories.data,
						true
					);
				});
			}
		}
	}
};